import createRootReducer from '../../reducers/apps/case-json';
import { thunk } from 'redux-thunk';
import logger from 'redux-logger';
import authMiddleware from '../../core/middleware/auth-middleware';
import { applyMiddleware, compose, createStore } from 'redux';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = createRootReducer();
const reducer = (state, action)=>{
    if (state && 'router' in state) {
        const { router, ...rest } = state;
        return rootReducer(rest, action);
    }
    return rootReducer(state, action);
};
const middlewares = [
    authMiddleware,
    thunk,
    !process.env.JEST_WORKER_ID && logger
].filter(Boolean);
const store = createStore(reducer, undefined, composeEnhancers(applyMiddleware(...middlewares)));
//const store = buildStore(rootReducer, {router});
export { store };
